import PropTypes from 'prop-types';
import React from 'react';
import Svg from 'rp-react-svg-icon';
import Matches from '../../Common/Matches';
import Results from '../../Common/Results';
import { profilesTypes } from '../profiles.utils';

/**
 * Profiles types list presentational component
 * Displays list of fetched profiles types. Displays spinner while fetching.
 */
export default function ProfilesTypesList({
    fetching,
    fetchFailed,
    items,
    itemsNum,
    onSelect,
}) {
    return (
        <div className="search-result_all">
            <h2 className="search-resultHeader">
                Matches <Matches itemsNum={itemsNum} />
            </h2>
            <Results
                itemsNum={itemsNum}
                fetching={fetching}
                error={fetchFailed}
            >
                <ul className="search-resultList">
                    {items.map(({ quantity, key }) => (
                        <li
                            key={key}
                            className="search-resultList__item"
                        >
                            <a
                                className="search-resultList__link ui-link ui-link_table"
                                href={`#${key}`}
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onSelect(key);
                                }}
                            >
                                <span className="search-resultList__linkLabel">
                                    {profilesTypes[key]}
                                </span>
                                <span className="search-resultList__linkCounter">
                                    {quantity}
                                </span>
                                <Svg
                                    iconName="right"
                                    size="Medium"
                                    className="search-resultList__linkIcon"
                                />
                            </a>
                        </li>
                    ))}
                </ul>
            </Results>
        </div>
    );
}

ProfilesTypesList.propTypes = {
    /**
     * True while application is fetching profiles types from server
     */
    fetching: PropTypes.bool.isRequired,
    /**
     * True if last profiles types fetching has failed
     */
    fetchFailed: PropTypes.bool.isRequired,
    /**
     * Array of fetched profiles types
     */
    items: PropTypes.arrayOf(PropTypes.shape({
        /**
         * Profiles type identifier
         */
        key: PropTypes.string.isRequired,
        /**
         * Overall number of available profiles by type
         */
        quantity: PropTypes.number.isRequired,
    })).isRequired,
    /**
     * Overall number of available profiles types
     */
    itemsNum: PropTypes.number.isRequired,
    /**
     * Function to handle click on profiles type
     */
    onSelect: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/Profiles/components/ProfilesTypesList.jsx